export default {
  RememberToken(state) {
    return state.token
  },
  RememberPhone(state) {
    return state.phone
  },
}
